/* eslint-disable import/no-default-export */
import {SliderGalleryController} from '../../viewerScript/SliderGalleryController';

export default SliderGalleryController;
